/** A route matches a nav path if it *is* that path or is nested under it. */
export function matchesSidebarPath(pathname: string, path: string): boolean {
  return pathname === path || pathname.startsWith(`${path}/`);
}
